// @flow

import React, { Component } from "react";
import { hot } from "react-hot-loader";

import { withHistory } from "./../HistoryContext/HistoryContext";
import FilterPanel from "./../FilterPanel/FilterPanel";
import ProductList from "./../ProductList/ProductList";
import ResultsInfo from "./../ResultsInfo/ResultsInfo";

type PropsType = {
	initialModel: TopicListViewModelType,
	initialPath: string,
	history: HistoryType
};

type StateType = {
	model: TopicListViewModelType,
	path: string,
	isLoading: boolean
};

export class App extends Component<PropsType, StateType> {

	constructor(props: PropsType) {
		super(props);

		this.state = {
			model: props.initialModel,
			path: props.initialPath,
			isLoading: false
		};
	}

	getPathAndQuery(): string {
		return location.pathname + location.search;
	}

	loadServerData(ajaxUrl: string): Promise<*> {
		const path: string = this.getPathAndQuery();
		this.setState({
			isLoading: true,
			path: path
		});
		return fetch(ajaxUrl)
			.then(response => response.json())
			.then(data => {
				if(path === this.getPathAndQuery())
					this.setState({
						model: data,
						path: path,
						isLoading: false });
			})
			.catch(error => {
				if(error && process.env.NODE_ENV !== "production") {
					console.error(error);
				}
				// Fallback to full page reload if we fail to load data
				location.assign(path);
			});
	}

	getAjaxLoadUrl(location: HistoryLocationType): string {
		// Append ajax=ajax to avoid caching pages based on url only and mixing html/json responses
		return `${ location.pathname }${ location.search }${ location.search ? "&" : "?" }ajax=ajax`;
	}

	componentDidMount() {
		this.props.history.listen(location => {
			this.loadServerData(this.getAjaxLoadUrl(location));
		});
	}

	getAppliedFilters(): TopicListAppliedFilterType[] {
		const mapOptions =
			(group: TopicListFilterGroupType) => group.options
				.filter(opt => opt.isSelected)
				.map(opt => ({
					groupTitle: group.title,
					optionLabel: opt.label,
					groupId: group.id,
					optionId: opt.id
				}));

		return this.state.model.filters
			.map(mapOptions)
			.reduce((arr, group) => arr.concat(group), []);
	}

	render() {
		return (
			<div className="container mt--d mb--e gtm-topic-list-page">
				<form method="GET" className="grid grid--loose">
					<div data-g="12 sm:5 md:4 lg:3" className="hide-print">
						<FilterPanel filters={this.state.model.filters}
							path={this.state.path} />
					</div>
					<div data-g="12 sm:7 md:8 lg:9">
						<ResultsInfo count={this.state.model.products.length}
							sortOrder={this.state.model.sort}
							appliedFilters={this.getAppliedFilters()}
							path={this.state.path}
							isLoading={this.state.isLoading} />
						<ProductList products={this.state.model.products} />
					</div>
					<input name="Sort" type="hidden" value={this.state.model.sort} />
				</form>
			</div>
		);
	}
}

export default hot(module)(withHistory(App));
